:host {
  display: contents;

  ::slotted(*) {
    @include visuallyhiddenFocusable;
  }
}

.stzh-visuallyhidden {
  display: contents;
}